import moment from 'moment';
import { useIntl } from 'react-intl';
import { TableList, Tag, Tooltip, TooltipInteractionEnum } from 'sonata-react-components';

type Props = {
  metrics: Record<string, any>[];
};

function LQIMetricsTooltip({ metrics }: Props) {
  const { formatMessage } = useIntl();

  const columns = [
    {
      Cell: ({ value }: { value: string }) => <div>{value}</div>,
      Header: formatMessage({
        defaultMessage: 'Identifier',
        id: 'targeting.lqi.indexMetrics.id'
      }),
      accessor: 'id'
    },
    {
      Cell: ({ value }: { value: Record<string, any> }) => (
        <div>{value?.dateRange?.from ? moment(value.dateRange.from).format('YYYY-MM-DD') : '—'}</div>
      ),
      Header: formatMessage({
        defaultMessage: 'From',
        id: 'targeting.lqi.indexMetrics.dateRangeFrom'
      }),
      accessor: 'dataSource'
    },
    {
      Cell: ({ row }: { row: Record<string, any> }) => (
        <div>
          {row.values.dataSource?.dateRange?.to ? moment(row.values.dataSource.dateRange.to).format('YYYY-MM-DD') : '—'}
        </div>
      ),
      Header: formatMessage({
        defaultMessage: 'To',
        id: 'targeting.lqi.indexMetrics.dateRangeTo'
      }),
      accessor: ''
    }
  ];

  return (
    <Tooltip
      config={{
        component: (
          <TableList
            // @ts-ignore
            columns={columns}
            config={{ pagination: { show: false }, type: 'table' }}
            data={metrics}
          />
        ),
        interactions: [TooltipInteractionEnum.hover],
        placement: 'right',
        strategy: 'fixed'
      }}
    >
      <Tag
        icon={{
          color: 'var(--color-sonata-primary-600, #3D5787);',
          position: 'left',
          webFont: 'fa-light fa-circle-info'
        }}
        id="lqi-metrics-tag"
        status="information"
      >
        {String(metrics.length)}
      </Tag>
    </Tooltip>
  );
}

export default LQIMetricsTooltip;
